import React, { memo } from "react";
import { EmptyState, EmptyStateIconBackground, EmptyStateProps } from "../../../EmptyState";
import { SearchIcon } from "../../../EmptyState/images";
import { FeaturedIcon } from "../../../MiscIcons";

export const EmptyPlaceholder = memo<EmptyStateProps>((props) => {
  return (
    <EmptyState
      size="sm"
      header="No records found"
      supportingText="Your search did not match any results. Please try again."
      icon={
        <EmptyStateIconBackground type="circle">
          <FeaturedIcon size="lg">
            <SearchIcon />
          </FeaturedIcon>
        </EmptyStateIconBackground>
      }
      {...props}
    />
  );
});

